export const isTurboPreview = () =>
  document.documentElement.hasAttribute('data-turbo-preview')
